module.exports = "/_next/static/images/0d71bd95a405bd3db02aee6d0e57f1fd-nubank-shooting-hands-diversity@1x.jpg";